<template>
    <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
        <div v-show="show" class="pt-32 relative w-full inline-block text-left overflow-hidden transform transition-all sm:my-8 sm:max-w-sm sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <h1 class="px-14 sm:px-12 text-2xl font-inter font-semibold text-center text-white" v-html="headline" />
            <h4 v-if="subtitle !== ''" :class="`px-20 sm:px-12 mt-2 text-base font-inter text-center text-${$root.theme}-200`" v-html="subtitle" />
            <div class="mt-6 px-20">
                <button @click="$emit('accepted')" type="button" :class="`w-full inline-flex text-${$root.theme}-900 justify-center rounded-md px-4 py-3 bg-white text-base font-medium hover:bg-${$root.theme}-200 focus:outline-none focus:ring-none sm:col-start-2 sm:text-sm`">
                    {{ acceptText }}
                </button>
                <a @click="$emit('declined')" class="mt-3 w-full inline-flex text-white justify-center text-sm font-medium focus:outline-none focus:ring-none sm:col-start-2 cursor-pointer">
                    {{ declineText }}
                </a>
            </div>
        </div>
    </transition>
</template>

<script>
import Mixins from '../../mixins';

export default {
    mixins: [Mixins],

    props: {
        show: {
            type: Boolean
        },
        headline: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        acceptText: {
            type: String,
            default: 'Yes please!'
        },
        declineText: {
            type: String,
            default: 'No thank you'
        }
    },

    watch: {
        show: {
            immediate: true,
            handler: function (show, oldShow) {
                if (show) {
                    this.gtagEvent('pdo-extra-shown');

                    window.addEventListener('mousemove', () => {
                        if (! this.mousemove) {
                            this.gtagEvent('pdo-extra-shown-with-activity');

                            this.mousemove = true;
                        }
                    });

                    window.addEventListener('scroll', () => {
                        if (! this.onscroll) {
                            this.gtagEvent('pdo-extra-shown-with-activity');

                            this.onscroll = true;
                        }
                    })
                }
            }
        }
    },

    data() {
        return {
            error: false,
            mousemove: false,
            onscroll: false
        }
    }
}
</script>